import http from '~/common/http'
export default {
    getCount(params, action) {
        return http.get('/api/guanbi-count/' + action, {
            params: params
        });
    },
}


// WEBPACK FOOTER //
// ./src/services/GuanbiCount.js